import React from 'react';
import OtpLoginPage from 'modules/restaurant/waiter-login/OtpLoginPage';

export default function OtpLogin() {
    return <OtpLoginPage />;
}
